<template>
    <div class="bg-white rounded-lg shadow-md p-5 lg:p-8 m-2 lg:mx-4 space-y-4">
        <div class="font-semibold text-gray-600 text-xl mb-4">Destinatario</div>

        <div class="flex space-x-4">
            <div class="w-1/2">
                <div class="text-gray-500 text-[12px] uppercase">Nombre</div>
                <div class="text-lg text-gray-800">
                    {{ envio.destino_nombre }}
                </div>
            </div>
            <div class="w-1/2">
                <div class="text-gray-500 text-[12px] uppercase">DNI</div>
                <div class="text-lg text-gray-800">
                    {{ envio.destino_documento }}
                </div>
            </div>
        </div>

        <div class="w-full">
            <div class="text-gray-500 text-[12px] uppercase">Telefono</div>
            <div class="text-lg text-gray-800">
                {{ envio.destino_telefono }}
            </div>
        </div>

        <div class="w-full">
            <div class="text-gray-500 text-[12px] uppercase">Email</div>
            <div class="text-lg text-gray-800">
                {{ envio.destino_email }}
            </div>
        </div>

        <div class="w-full">
            <div class="text-gray-500 text-[12px] uppercase">Calle</div>
            <div class="text-lg text-gray-800">
                {{ envio.destino_calle }}
            </div>
        </div>

        <div class="flex space-x-4">
            <div class="w-1/2">
                <div class="text-gray-500 text-[12px] uppercase">Altura</div>
                <div class="text-lg text-gray-800">
                    {{ envio.destino_altura }}
                </div>
            </div>

            <div class="w-1/2">
                <div class="text-gray-500 text-[12px] uppercase">Piso</div>
                <div class="text-lg text-gray-800">
                    {{ envio.destino_piso === null ? "-" : envio.destino_piso }}
                </div>
            </div>
        </div>

        <div class="flex space-x-4">
            <div class="w-1/2">
                <div class="text-gray-500 text-[12px] uppercase">Dpto.</div>
                <div class="text-lg text-gray-800">
                    {{ envio.destino_dpto === null ? "-" : envio.destino_dpto }}
                </div>
            </div>
            <div class="w-1/2">
                <div class="text-gray-500 text-[12px] uppercase">
                    Codigo Postal
                </div>
                <div class="text-lg text-gray-800">
                    {{ envio.destino_cp }}
                </div>
            </div>
        </div>

        <div class="flex space-x-4">
            <div class="w-1/2">
                <div class="text-gray-500 text-[12px] uppercase">Localidad</div>
                <div class="text-lg text-gray-800">
                    {{ envio.destino_localidad }}
                </div>
            </div>
            <div class="w-1/2">
                <div class="text-gray-500 text-[12px] uppercase">Provincia</div>
                <div class="text-lg text-gray-800">
                    {{ envio.destino_provincia }}
                </div>
            </div>
        </div>

        <div v-if="envio.destino_observacion" class="w-full">
            <div class="text-gray-500 text-[12px] uppercase">Observación</div>
            <div class="text-lg text-gray-800">
                {{ envio.destino_observacion }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DestinationPanel",
    props: {
        envio: Object,
    },
};
</script>
